import { Download, Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { Button, Dialog, Flex, Text } from '@/components/common';
import { UserContext } from '@/contexts';
import { usePwaInstall } from '@/hooks';

export function PwaInstallPrompt() {
  const { t } = useTranslation('common');
  const userContext = useContext(UserContext);
  const { canInstall, isIOS, prompt, dismiss } = usePwaInstall();

  const alreadyInstalled = (userContext?.currentUser?.pwaInstalledAt?.length ?? 0) > 0;

  if (!canInstall || alreadyInstalled) return null;

  const handleInstall = async () => {
    await prompt();
  };

  const subtitle = isIOS ? t('installPrompt.iosSubtitle') : t('installPrompt.subtitle');

  return (
    <Dialog.Root open={canInstall} onOpenChange={open => !open && dismiss()}>
      <Dialog.Content size="2" maxWidth="320px" aria-describedby={undefined}>
        <Dialog.Title className="sr-only">{t('installPrompt.title')}</Dialog.Title>

        <Flex direction="column" align="center" gap="4">
          <Flex align="center" justify="center" className="shrink-0 rounded-full bg-accent-9 p-3">
            {isIOS ? <Smartphone size={28} color="black" /> : <Download size={28} color="black" />}
          </Flex>

          <Flex direction="column" align="center" gap="1">
            <Text size="3" weight="bold" className="text-center">
              {t('installPrompt.title')}
            </Text>
            <Text size="2" color="gray" className="text-center leading-tight">
              {subtitle}
            </Text>
          </Flex>

          <Flex direction="row" justify="between" align="center" gap="3" className="w-full">
            <Button
              type="button"
              size="md"
              color="gray"
              variant="soft"
              className="flex-1"
              onClick={dismiss}
            >
              {t('installPrompt.dismiss')}
            </Button>

            {!isIOS && (
              <Button type="button" size="md" className="flex-1" onClick={handleInstall}>
                {t('installPrompt.install')}
              </Button>
            )}
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
